import type {WalkerService} from 'shared/services';
import type {Rec} from 'src/typings';
import {getRecordPath, getRecordUrlId} from 'shared/utils/data-service-utils';
import type {FavouritesCollectionService} from '../../favourites/favourites-collection.service';

export class SearchPageService {
    public static serviceName = 'searchPageService';

    /*@ngInject*/
    constructor(private favouritesCollectionService: FavouritesCollectionService,
                private walker: WalkerService) {
    }
    public async getFavouritesCollectionManager() {
        return this.favouritesCollectionService.getFavouritesCollectionManager();
    }

    public registerPotentials(records: Rec[]) {
        records.forEach((record) => this.favouritesCollectionService.registerPotential(record));
    }

    public clearPotentials() {
        this.favouritesCollectionService.clearPotentials();
    }

    public goToRecord(record: Rec) {
        return this.walker.newPage(getRecordPath(getRecordUrlId(record)));
    }
}